$('#CproductPageAddToCart').on('click', function(e){
    e.preventDefault();
    $.ajax({
        type:'POST',
        url:'/cart/add.js',
        data:$('.product_form_id_with_box').serialize(),
        dataType:'json',
        success:function(data){
            cartUpdate()
            $(this).text('Added')
        },
        error:function(err){ 
            console.log('error')
        }
    });
});
$('#CproductPageAddToCartmolding').on('click', function(e){
    e.preventDefault();
    $.ajax({
        type:'POST',
        url:'/cart/add.js',
        data:$('.product_form_id_with_box').serialize(),
        dataType:'json',
        success:function(data){
            cartUpdate()
            $(this).text('Added')
        },
        error:function(err){ 
            console.log('error')
        }
    });
});
$('#CustomAddSampleToCartPDP').on('click', function(e){
    e.preventDefault();
    $.ajax({
        type:'POST',
        url:'/cart/add.js',
        data:$('#product_form_id_sample').serialize(),
        dataType:'json',
        success:function(data){
            cartUpdate()
            $(this).text('Added')
        },
        error:function(err){ 
            console.log('error')
        }
    });
});
// $('.c_custom_add_button_cart').on('click', function(e){
//     e.preventDefault();

//     var $button = $(this);
//     var $form = $button.closest('form');

//     $button.prop('disabled', true).text('Adding...');

//     $.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         data: $form.serialize(),
//         dataType: 'json',
//         success: function(data){
//             cartUpdate();
//             $button.text('Added!');
//         },
//         error: function(err){ 
//             console.log('error');
//             $button.prop('disabled', false).text('+ Add Sample');
//         }
//     });
// });
$(document).on('click', '.c_custom_add_button_cart', function(e){
    e.preventDefault();

    var $button = $(this);
    var $form = $button.closest('form');

    $button.prop('disabled', true).text('Adding...');

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: $form.serialize(),
        dataType: 'json',
        success: function(data){
            cartUpdate();
            $button.text('Added!');
        },
        error: function(err){ 
            console.log('error');
            $button.prop('disabled', false).text('+ Add Sample');
        }
    });
  });

function cartUpdate(){
    $.getJSON('/cart.js', function(cart){
        var cartWidget = $('#shopify-section-ar-slide-cart');
        var cartOverlay = $('.c_custom_overlay_mini_cart');

        cartWidget.addClass('active');
        cartOverlay.addClass('active');
        cartUpdateData()
        var cartItemCount = $('.cart_item_count');
        cartItemCount.text(cart.item_count)
    });
};
function cartUpdateRemove(){
    $.getJSON('/cart.js', function(cart){
        var cartItemCount = $('.cart_item_count');
        cartItemCount.text(cart.item_count)
    });
};

function itemRemove(e, el){
    var id = $(el).data('id')
    $.ajax({
        type:"POST",
        url:'/cart/change.js',
        data: {
            id: id,
            quantity:0
        },
        success:function(data){
            cartUpdateData()
            cartUpdateRemove()
        },
        error:function(err){
          console.log("Error")
        }
    })
};

// function toggleDiscountBanner() {
//     const progressBar = document.querySelector('.c_cart_discount_pregress_inner');
//     const discountBanner = document.querySelector('.c_slide_cart_discount_banner');
  
//     if (progressBar && discountBanner) {
//       const width = parseFloat(getComputedStyle(progressBar).width);
  
//       if (width === 0) {
//         discountBanner.style.display = 'block';
//       } else {
//         discountBanner.style.display = 'block';
//       }
//     }
// }
  

function cartUpdateData(){
    fetch('/?section_id=ar-slide-cart')
    .then(response => response.text())
    .then(cartData => {
        var cartHtml = $(cartData);
        var cartItems = $('.ajax_c_cart_item_wrapper', cartHtml);
        $('.ajax_c_cart_item_wrapper').replaceWith(cartItems);
        var cartItems = $('.cart_header_count', cartHtml);
        $('.cart_header_count').replaceWith(cartItems);
        var cartItems = $('.c_subtotal_wrap', cartHtml);
        $('.c_subtotal_wrap').replaceWith(cartItems);
        var cartItems = $('.c_slide_cart_discount_banner', cartHtml);
        $('.c_slide_cart_discount_banner').replaceWith(cartItems);
    })
}

// Cart Quantity update 

$(document).on('click', '.increase-qty', function(e) {
  e.preventDefault();

  var $button = $(this);
  var $input = $button.siblings('.qty-input');
  var currentQty = parseInt($input.val());

  if ($button.hasClass('increase-qty')) {
    currentQty++;
  } 
  // else if ($button.hasClass('decrease-qty') && currentQty > 1) {
  //   currentQty--;
  // }

  $input.val(currentQty);
});

function itemplus(e, el){
  var id = $(el).data('id');
  var qty = $(el).prev().val();
  qty = parseInt(qty) + 1;
  
  $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        id: parseFloat(id),
        quantity: qty
      },
      dataType: 'json',
      success: function(data){
          cartUpdate();
      },
      error: function(err){ 
          console.log('error');
      }
  });
}


function itemMinus(e, el) {
  var id = $(el).data('id');
  var qtyInput = $(el).next();
  var qty = parseInt(qtyInput.val()) - 1;

  var variantTitle = $(el).closest('.quantity-controls').data('variant');

  if (variantTitle === 'Full Box' && qty < 10) {
    window.alert('Minimum Order quantity is 10 boxes. Please ensure you add the minimum order quantity required.');
    return;
  }

  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: {
      id: parseFloat(id),
      quantity: qty
    },
    dataType: 'json',
    success: function(data){
        cartUpdate();
    },
    error: function(err){ 
        console.log('error');
    }
  });
};